export default __webpack_public_path__ + "static/media/close.d7727f0c.svg";